import type { To } from 'react-router-dom';
import { useViewTransitionState as baseUseViewTransitionState } from 'react-router-dom';

export const useViewTransitionState = (path: To) => {
  let isTransitioning = false;
  try {
    isTransitioning = baseUseViewTransitionState(path);
  } catch {
    // mostly for storybook where the story is not wrapped in StoryDecorator
  }
  return isTransitioning;
};
